import { render, staticRenderFns } from "./NuevoPersonal.vue?vue&type=template&id=de7b33e8&"
import script from "./NuevoPersonal.vue?vue&type=script&lang=js&"
export * from "./NuevoPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports